export default __webpack_public_path__ + "static/media/googleplay.5b53ad85.png";